"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const ProfilePhoto_1 = require("../models/ProfilePhoto");
function transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany(aggregableData) {
    const result = [];
    aggregableData.forEach((ad) => {
        if (ad.profilePhoto?.status === undefined) {
            ad.profilePhoto = (0, class_transformer_1.plainToClass)(ProfilePhoto_1.ProfilePhoto, ad.profilePhoto);
        }
        const customerFeedbackForDriver = {
            originLocationName: ad.originLocationName,
            destinationLocationName: ad.destinationLocationName,
            departureAt: ad.departureAt,
            text: ad.feedback.text,
            textScore: ad.feedback.textScore,
            locationNames: ad.locationNames,
            driverName: ad.driverName,
            driverProfileImageUrl: ad.profilePhoto?.status === legacy_enums_1.ProfilePhotoStatus.Accepted
                ? `${legacy_config_1.API_OPEN_PROFILE_IMAGE_URL}?userId=${ad.feedback.driverUserId}`
                : undefined,
        };
        result.push(customerFeedbackForDriver);
    });
    return result;
}
exports.transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany = transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany;
//# sourceMappingURL=transformCustomerFeedbackAggregableDataToCustomerFeedbackForCompany.js.map